import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { useIntl, FormattedMessage } from 'react-intl'
import Link from '../Link'
import * as styles from './index.module.css'

const DistributorRegion = ({ title, components }) => {
  const intl = useIntl()
  const translatedAlt = intl.formatMessage({ id: 'distributor.logo' })

  return (
    <div className="wrapper">
      <div className={styles.container}>
        <h3 className={`${styles.title} h2`}>{title}</h3>
        {components.map((distributor, idx) => (
          <div className={styles.wrapper} key={idx}>
            <div className={styles.distributorContainer}>
              <div className={styles.logoContainer}>
                <Link to={distributor.ctaUrl} target="_blank">
                  <GatsbyImage
                    image={distributor.gatsbyImageData}
                    imgStyle={{
                      objectFit: 'contain',
                    }}
                    className={styles.logo}
                    alt={`${translatedAlt} ${distributor.title}`}
                  />
                </Link>
              </div>
              <div className={styles.info}>
                <Link to={distributor.ctaUrl} target="_blank">
                  <div className={`${styles.name} h3`}>{distributor.title}</div>
                </Link>
                {typeof window !== `undefined` && window.innerWidth > 450 && (
                  <div className={styles.attributes}>
                    <div className={styles.col}>
                      <h4>
                        <FormattedMessage id="distributor.regions" />
                      </h4>
                      <h4>
                        <FormattedMessage id="distributor.services" />
                      </h4>
                    </div>
                    <div className={styles.col}>
                      <div>
                        {distributor.subtitle.subtitle.trim().split('\n')[0]}
                      </div>
                      <div>
                        {distributor.subtitle.subtitle.trim().split('\n')[1]}
                      </div>
                    </div>
                  </div>
                )}

                {typeof window !== `undefined` && window.innerWidth <= 450 && (
                  <div className={styles.attributes}>
                    <div className={styles.row}>
                      <h4>
                        <FormattedMessage id="distributor.regions" />
                      </h4>
                      <div>
                        {distributor.subtitle.subtitle.trim().split('\n')[0]}
                      </div>
                    </div>
                    <div className={styles.col}>
                      <h4>
                        <FormattedMessage id="distributor.services" />
                      </h4>
                      <div>
                        {distributor.subtitle.subtitle.trim().split('\n')[1]}
                      </div>
                    </div>
                  </div>
                )}

                {typeof window !== `undefined` && window.innerWidth > 450 && (
                  <div className={styles.description}>
                    {distributor.subtitle.subtitle.trim().split('\n')[2]}
                  </div>
                )}
              </div>
            </div>
            {typeof window !== `undefined` && window.innerWidth <= 450 && (
              <div className={styles.description}>
                {distributor.subtitle.subtitle.trim().split('\n')[2]}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default DistributorRegion
